














































import { Component, Prop, Mixins } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import Util from "../../../lib/util";

@Component
export default class EditImage extends Mixins(AbpBase) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  isUpload: boolean = false;
  imageUrl: string = "";
  thumbnailUrl: string = "";

  get editProduct() {
    return this.$store.state.product.editProduct;
  }

  save() {
    if(this.thumbnailUrl == "" || this.thumbnailUrl == null)
    {
      Util.showNoticeErrorMsg(this, "Chưa có upload hình ảnh");
      return;
    }
    this.editProduct.thumbnailUrlNew = this.thumbnailUrl;
    this.$emit("input", false);
    this.$emit("on-confirm-save");
  }
  cancel() {
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.handleRemoveAvatar();
      this.$emit("input", value);
    }
  }
  handleRemoveAvatar() {
    this.isUpload = false;
    this.imageUrl = "";
    this.thumbnailUrl = "";
  }
  handleBeforeUpload(file) {
    const fileExt = file.name.split(".").pop().toLocaleLowerCase();

    if (
      fileExt === "jpep" ||
      fileExt === "jpg" ||
      fileExt === "png" ||
      fileExt === "gif" ||
      fileExt === "jfif"
    ) {
      let data = new FormData();
      data.append("file", file);

      this.$store.dispatch("product/uploadProductImage", data).then((res) => {
        this.thumbnailUrl = res;
        this.imageUrl = Util.getAppUrlImage(res);
        this.isUpload = true;
      });
    }

    return false;
  }
}
